/* EdenColor — restrictions d'eau du jour, pages sécheresse (Carte sécheresse et pages
   département). 02/10/2026.

   Les données sont lues à chaque visite, dans le navigateur du visiteur :
   - VigiEau (ministère de la Transition écologique), api.vigieau.gouv.fr :
     /api/departements (niveau le plus haut par département et par eau),
     /api/zones (zones et règles à une adresse, profil particulier) ;
   - Géoplateforme de l'IGN, data.geopf.fr/geocodage : adresse -> position et code commune.
   EdenColor ne reçoit pas l'adresse. Elle n'est gardée sur l'appareil que si le visiteur
   coche « Retenir cette adresse ».

   Tout texte venu de ces services passe par textContent, jamais par innerHTML.

   Branchements (attributs posés par les sections ec-secheresse-departement et
   ec-carte-secheresse, et par le snippet ec-secheresse-adresse) :
   [data-ec-rst-etat="86"]        état du département : [data-ec-rst-eau="AEP|SUP|SOU"] [data-ec-rst-niv], [data-ec-rst-date],
                                  [data-ec-rst-verdicts] (réponses du jour), script[data-ec-rst-regles] (tableau des règles)
   [data-ec-rst-dep] > [data-ec-rst-niv]   pastille d'un département voisin (eau du robinet)
   [data-ec-rst-carte]            carte de France : onglets [data-ec-rst-champ], svg path[data-dep], légende, liste, panneau
   [data-ec-rst-adresse]          vérification par adresse (data-dep = département de la page, vide sur la carte,
                                  data-dans = « dans la Vienne »)
   script[data-ec-rst-pages]      pages département en ligne, écrit par seo/scripts/pages-secheresse.py */
(function () {
  'use strict';

  var API = 'https://api.vigieau.gouv.fr/api';
  var GEO = 'https://data.geopf.fr/geocodage/search';
  var VIGIEAU = 'https://vigieau.gouv.fr/';
  var GUIDE = 'https://www.ecologie.gouv.fr/guide-secheresse-mise-en-oeuvre-des-mesures-restriction-des-usages-leau-en-periode-secheresse';
  var CLE = 'ec-rst-adresse';

  var NIV = { vigilance: 1, alerte: 2, alerte_renforcee: 3, crise: 4 };
  var NOMS = ['Aucune restriction', 'Vigilance', 'Alerte', 'Alerte renforcée', 'Crise'];
  // nom : onglets et panneau de la carte. titre : en-tête des réponses. court : pour dire
  // « avec l'eau du robinet ou d'un puits » quand deux eaux ont la même réponse.
  var EAUX = [
    { type: 'AEP', cle: 'aep', champ: 'niveauGraviteAepMax', nom: 'Robinet',
      titre: "Avec l'eau du robinet", court: 'du robinet' },
    { type: 'SUP', cle: 'sup', champ: 'niveauGraviteSupMax', nom: 'Rivières',
      titre: "Avec l'eau d'une rivière ou d'un étang", court: "d'une rivière" },
    { type: 'SOU', cle: 'sou', champ: 'niveauGraviteSouMax', nom: 'Puits et nappes',
      titre: "Avec l'eau d'un puits ou d'un forage", court: "d'un puits" }
  ];
  var CHAMPS = { aep: 'niveauGraviteAepMax', sup: 'niveauGraviteSupMax', sou: 'niveauGraviteSouMax', max: 'niveauGraviteMax' };

  /* ---------- outils ---------- */

  function el(tag, cls, texte) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (texte != null) n.textContent = texte;
    return n;
  }

  function lien(href, texte) {
    var a = el('a', null, texte);
    a.href = href;
    if (/^https?:\/\//.test(href) && href.indexOf(location.host) < 0) { a.target = '_blank'; a.rel = 'noopener'; }
    return a;
  }

  function vider(n) { while (n.firstChild) n.removeChild(n.firstChild); }

  function niveau(v) { return v && NIV[v] ? NIV[v] : 0; }

  function disponible(dep) {
    var a = dep && dep.availability && dep.availability.AEP;
    return !(a && a.status === 'unavailable');
  }

  function poserPuce(span, n) {
    span.className = span.className.replace(/\s*(ec-niv--\w+|ec-rst__puce--vide)/g, '');
    if (n === 'x') { span.className += ' ec-rst__puce--vide'; span.textContent = 'Indisponible'; }
    else { span.className += ' ec-niv--' + n; span.textContent = NOMS[n]; }
  }

  function puce(n, petite) {
    var s = el('span', 'ec-rst__puce' + (petite ? ' ec-rst__puce--petite' : ''));
    poserPuce(s, n);
    return s;
  }

  function niveauDep(dep, champ) { return disponible(dep) ? niveau(dep[champ]) : 'x'; }

  function lireJSON(url) {
    return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) { var e = new Error('HTTP ' + r.status); e.status = r.status; throw e; }
      return r.json();
    });
  }

  var formats = {};
  function date(iso, avecHeure) {
    if (!iso) return '';
    try {
      var k = avecHeure ? 'h' : 'j';
      formats[k] = formats[k] || new Intl.DateTimeFormat('fr-FR', avecHeure
        ? { dateStyle: 'long', timeStyle: 'short', timeZone: 'Europe/Paris' }
        : { dateStyle: 'long', timeZone: 'Europe/Paris' });
      return formats[k].format(new Date(iso));
    } catch (e) { return ''; }
  }

  // Une seule lecture de /departements par page, partagée par tous les blocs.
  var promesseDeps = null;
  function departements() {
    if (!promesseDeps) {
      promesseDeps = lireJSON(API + '/departements').then(function (liste) {
        var parCode = {}, asOf = '';
        liste.forEach(function (d) {
          parCode[d.code] = d;
          var a = d.availability && d.availability.AEP && d.availability.AEP.asOf;
          if (a && a > asOf) asOf = a;
        });
        liste.sort(function (a, b) { return a.code.localeCompare(b.code, 'fr', { numeric: true }); });
        return { liste: liste, parCode: parCode, asOf: asOf };
      });
      promesseDeps.catch(function () { promesseDeps = null; });
    }
    return promesseDeps;
  }

  var pagesDep = null;
  function pages() {
    if (!pagesDep) {
      pagesDep = {};
      var s = document.querySelector('script[data-ec-rst-pages]');
      try { if (s) pagesDep = JSON.parse(s.textContent) || {}; } catch (e) { pagesDep = {}; }
    }
    return pagesDep;
  }

  // Les zones d'un département, lues seulement quand une adresse est à un niveau plus bas que
  // la couleur du département : pour dire quelles zones lui donnent cette couleur.
  var cacheZones = {};
  function zonesDep(code) {
    if (!cacheZones[code]) {
      cacheZones[code] = lireJSON(API + '/zones/departement/' + encodeURIComponent(code));
      cacheZones[code].catch(function () { delete cacheZones[code]; });
    }
    return cacheZones[code];
  }

  // Le nom des zones « robinet » est un nom de fichier administratif (Liste_Crise_AEP_…) : on ne cite que les autres.
  function nomsZones(zs) {
    var noms = [];
    (zs || []).forEach(function (z) {
      var n = z && z.type !== 'AEP' && normalNom(z.nom);
      if (n && noms.indexOf(n) < 0) noms.push(n);
    });
    return noms;
  }
  function enumerer(l) { return l.length < 2 ? l.join('') : l.slice(0, -1).join(', ') + ' et ' + l[l.length - 1]; }
  var CHIFFRES = ['', 'une', 'deux', 'trois', 'quatre'];

  function messageVigieau(n, texte) {
    vider(n);
    n.appendChild(document.createTextNode(texte + ' Les niveaux restent consultables sur '));
    n.appendChild(lien(VIGIEAU, 'vigieau.gouv.fr'));
    n.appendChild(document.createTextNode('.'));
  }

  /* ---------- lire une règle : permis ou interdit ---------- */

  // Lire une règle de préfecture et en tirer une réponse simple : oui, non, à certaines
  // heures. Le texte est libre, écrit par chaque préfecture : dans le doute, on ne
  // répond pas « oui », on renvoie au texte (sens « lire »).
  var H = '(\\d{1,2})\\s*(?:h|:)\\s*(\\d{2})?|minuit|midi';
  var PLAGE = new RegExp('(?:\\bde|\\bentre|\\bdès)\\s+(' + H + ')\\s*(?:à|a|et|jusqu\'à)\\s+(' + H + ')|(' + H + ')\\s*[-–]\\s*(' + H + ')', 'g');
  var SAUF = /\bsauf\b|\bexcept|à l'exception|\bhors\b|dérogation|toutefois|\badaptations?\b|\bpour les\b|cas particuliers?/;
  var INTERDIT = /interdi\w*|fermée?s?\b|\barr[êe]t des?\b|coupure/;

  function minutes(txt) {
    if (/minuit/.test(txt)) return 24 * 60;
    if (/midi/.test(txt)) return 12 * 60;
    var m = /(\d{1,2})\s*(?:h|:)\s*(\d{2})?/.exec(txt);
    if (!m) return null;
    var v = (+m[1]) * 60 + (+(m[2] || 0));
    return v === 0 ? 24 * 60 : v;
  }

  function plages(t) {
    var r = [], m;
    PLAGE.lastIndex = 0;
    while ((m = PLAGE.exec(t))) {
      var a = minutes(m[1] || m[7]), b = minutes(m[4] || m[10]);
      if (a == null || b == null || a === b || a > 1440 || b > 1440) continue;
      // Même plage répétée, ou plage inverse (« interdit de 8h à 20h et limité entre 20h et 8h »).
      if (!r.some(function (x) { return x[0] === a && x[1] === b || x[0] === b && x[1] === a; })) r.push([a, b]);
    }
    return r;
  }

  function heure(v) {
    if (v === 1440 || v === 0) return 'minuit';
    var h = Math.floor(v / 60), mn = v % 60;
    return h + ' h' + (mn ? ' ' + (mn < 10 ? '0' : '') + mn : '');
  }

  // Une plage permise [a, b] (b < a : elle passe minuit).
  function duree(a, b) { return a > b ? 1440 - a + b : b - a; }
  function permisDe(a, b) {
    if (b === 1440 && a >= 17 * 60) return 'Oui, le soir après ' + heure(a);
    if (a > b) {
      return 'Oui, avant ' + heure(b) + ' ou après ' + heure(a);
    }
    return 'Oui, seulement de ' + heure(a) + ' à ' + heure(b);
  }

  // Une plage horaire ne dit pas tout : volume, jours, matériel.
  var CONDITION = /limit|uniquement|seulement|au plus|maximum|arrosoir|goutte|au pied|hebdo|par semaine|un jour sur|jours? pairs?|impairs?|réduction|réduire/;
  function heures(texte, t, d) {
    return { sens: 'heures', texte: texte + (CONDITION.test(t) ? ', sous conditions' : ''), duree: d };
  }

  function normal(texte) {
    return (texte || '').replace(/[​-‍﻿]/g, '').replace(/[’`]/g, "'").replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function verdict(texte, type) {
    var t = normal(texte);
    // « Milieu naturel : … Eau potable : … » : deux règles dans un texte, selon l'eau utilisée.
    var s = /milieu naturel\s*:(.*?)eau potable\s*:(.*)/.exec(t);
    if (s && type) t = (type === 'AEP' ? s[2] : s[1]).trim();
    if (!t) return { sens: 'lire' };
    var i = t.search(SAUF);
    var tete = i >= 0 ? t.slice(0, i) : t, reste = i >= 0 ? t.slice(i) : '';
    var m = INTERDIT.exec(tete);
    if (m) {
      // La plage horaire doit tenir dans la phrase de l'interdiction : « Interdit. Cas
      // particuliers : de 9h à 20h pour les arbres » interdit tout le reste de la journée.
      var fin = m.index + m[0].length, apres = tete.slice(fin);
      var coupe = /^\s*(totale?s?)?\s*[,.;(]|^\s*$/.test(apres) ? 0 : apres.search(/[.;](\s|$)/), suite = '';
      if (coupe >= 0) { suite = tete.slice(fin + coupe); tete = tete.slice(0, fin + coupe); }
      var sauf = !!reste || SAUF.test(suite) || /autoris/.test(suite);
      var p = plages(tete);
      if (p.length === 1) return heures(permisDe(p[0][1], p[0][0]), t, duree(p[0][1], p[0][0]));
      if (p.length > 1) return heures('Oui, sauf ' + p.map(function (x) { return 'de ' + heure(x[0]) + ' à ' + heure(x[1]); }).join(' et '), t,
        1440 - p.reduce(function (s, x) { return s + duree(x[0], x[1]); }, 0));
      // « Interdit sauf de 20h à 8h » : l'exception n'est qu'une plage horaire.
      var q = plages(reste);
      if (q.length === 1 && reste.replace(PLAGE, '').replace(/sauf|uniquement|seulement|[\s,.;:()-]/g, '').length < 3) {
        return heures(permisDe(q[0][0], q[0][1]), t, duree(q[0][0], q[0][1]));
      }
      if (/circuit ouvert/.test(t)) return { sens: 'non', sauf: true, texte: 'Non, sauf en circuit fermé' };
      return { sens: 'non', sauf: sauf };
    }
    if (/interdi/.test(t)) return { sens: 'lire' };
    if (/^(pas de|aucune|sans) restriction/.test(t) || /^autoris[ée]+s?\.?$/.test(t)) return { sens: 'oui' };
    var a = /autoris/.test(tete) && plages(tete);
    if (a && a.length === 1) return heures(permisDe(a[0][0], a[0][1]), t, duree(a[0][0], a[0][1]));
    if (/pas de restriction/.test(t)) return { sens: 'econome' };
    if (/strict (nécessaire|minimum)/.test(t)) return { sens: 'strict' };
    if (/sensibilis|incit|économ|optimis|gaspill|informa|communiqué|responsable|bon usage|vigilance/.test(t) &&
        !/interdi|limit|réduc|restrei|report|suspen|arr[êe]t|maximum|strict/.test(t)) return { sens: 'econome' };
    return { sens: 'lire' };
  }

  // Les questions qu'un jardinier se pose, rapprochées des usages des arrêtés.
  // Un usage va à la première question qui le reconnaît. « exclu » écarte ce qui
  // vise les professionnels, les collectivités ou les lieux ouverts au public.
  var HORS = /professio|accueillant du public|ouvert\w* au public|accessibles? .*au public|collectivit|exploitation|élevage|industri|\bstations?\b/i;
  // Lieux qui, seuls, ne sont pas un jardin ; dans une liste qui cite la pelouse, la règle vaut aussi pour elle.
  var LIEUX = /golfs?(?! particuliers)|terrains? de sport|stades?|hippodrome|cimeti/i;
  var JARDIN = /pelouse|potager|massif|jardin|espaces? verts?|fontaine|piscine/i;
  var QUESTIONS = [
    { cle: 'potager', titre: 'Arroser le potager', motif: /potager|plants destinés à l'alimentation/i, exclu: /non[- ]potager/i },
    { cle: 'facade', titre: 'Nettoyer la terrasse, la façade ou la toiture', motif: /fa[cç]ade|toiture|terrasse/i, exclu: /autres? que (les )?fa[cç]ades|espaces publics|bâtiments prof/i },
    { cle: 'piscine', titre: function (n) {
        var r = /rempli|maintien|remise à niveau|mise à niveau/i.test(n), v = /vidang/i.test(n);
        return r && !v ? 'Remplir la piscine' : v && !r ? 'Vider la piscine' : 'Remplir ou vider la piscine';
      }, motif: /piscine|\bspas?\b|bains? à remous/i, exclu: /(?:^|[^n][^o][^n][ -])collecti|à usage collectif|publique(?! ou priv)/i },
    { cle: 'voiture', titre: 'Laver la voiture chez vous', motif: /v[ée]hicule|voiture/i, exclu: /aire de lavage|commerci|organisme|haute pression|portique/i },
    { cle: 'fontaine', titre: 'Faire tourner une fontaine d\'ornement', motif: /fontaine/i, exclu: /douche|potable|fontaines? publiques?\b(?! *(\(.*\) *)?(et|ou) )/i },
    { cle: 'arbres', titre: 'Arroser les arbres, arbustes et haies', motif: /^(arrosage|irrigation),? (des |d'|de )?(jeunes )?(arbres|arbustes|haies|plantations|plants ligneux)/i },
    { cle: 'pelouse', titre: 'Arroser la pelouse et les massifs', motif: /pelouse|massif|espaces? verts?|jardins? d'agrément|espaces? arborés|jardinières|plates-bandes|végétaux|plantes/i, exclu: /espaces? verts? publics?\b(?! *(et|ou) )/i }
  ];

  function question(nom) {
    // « hors station de lavage », « en dehors des activités industrielles » : ce qui suit est écarté, pas visé.
    var n = normalNom(nom).replace(/\((?:hors|sauf|en dehors|ne concerne pas)[^)]*\)?/gi, '')
      .replace(/\b(?:hors|en dehors d(?:es?|u|')|sauf)\s*[^,;)]*/gi, '');
    if (HORS.test(n) || /non cités/i.test(n) || LIEUX.test(n) && !JARDIN.test(n)) return null;
    for (var i = 0; i < QUESTIONS.length; i++) {
      var q = QUESTIONS[i];
      if (q.motif.test(n) && !(q.exclu && q.exclu.test(n))) return q;
    }
    return null;
  }
  function normalNom(nom) { return (nom || '').replace(/[’`]/g, "'").replace(/\s+/g, ' ').trim(); }

  // Plusieurs usages pour une même question : on garde la réponse la plus stricte,
  // et on montre tous les textes officiels dessous.
  var RANG = { oui: 0, econome: 1, strict: 2, heures: 3, lire: 4, nonsauf: 5, non: 6 };
  function rang(v) { return RANG[v.sens === 'non' && v.sauf ? 'nonsauf' : v.sens]; }
  function plusStricte(a, b) {
    if (rang(b) !== rang(a)) return rang(b) > rang(a) ? b : a;
    return b.sens === 'heures' && b.duree < a.duree ? b : a;
  }
  var LIBELLES = { oui: 'Oui', econome: "Oui, en économisant l'eau", strict: 'Oui, au strict nécessaire', lire: 'Cela dépend : lisez la règle ci-dessous', non: 'Non' };
  function libelle(v) { return v.texte || (v.sens === 'non' && v.sauf ? 'Non, sauf exceptions' : LIBELLES[v.sens]); }
  function couleur(v) { return v.sens === 'oui' || v.sens === 'econome' ? 'oui' : v.sens === 'non' ? 'non' : v.sens === 'lire' ? 'lire' : 'heures'; }

  function reponses(usages, type) {
    var parCle = {}, ordre = [];
    usages.forEach(function (u) {
      var q = question(u.nom);
      if (!q) return;
      var titre = typeof q.titre === 'function' ? q.titre(normalNom(u.nom)) : q.titre;
      // « Fontaines en circuit ouvert : interdites » : la précision est dans le nom de l'usage.
      var desc = u.description || '';
      if (/circuit ouvert/i.test(u.nom) && !/circuit ouvert/i.test(desc)) desc += ' (en circuit ouvert)';
      var k = q.cle + '|' + titre, v = u.verdict ? verdictSaisi(u.verdict, desc) : verdict(desc, type);
      if (!parCle[k]) { parCle[k] = { titre: titre, cle: q.cle, k: k, v: v, usages: [] }; ordre.push(k); }
      else parCle[k].v = plusStricte(parCle[k].v, v);
      if (!parCle[k].usages.some(function (x) { return x.nom === u.nom && x.description === u.description; })) parCle[k].usages.push(u);
    });
    return ordre.map(function (k) { return parCle[k]; }).sort(function (a, b) {
      return ORDRE.indexOf(a.cle) - ORDRE.indexOf(b.cle);
    });
  }
  // Ordre d'affichage : ce que l'on fait le plus souvent d'abord.
  var ORDRE = ['pelouse', 'potager', 'arbres', 'piscine', 'voiture', 'facade', 'fontaine'];

  // La réponse écrite dans le tableau des règles d'une page (« Non, sauf exceptions | Vidange
  // et remplissage interdits… », snippet ec-secheresse-cellule) passe avant celle tirée du texte.
  function verdictSaisi(r, desc) {
    var t = (r || '').replace(/\s+/g, ' ').trim();
    if (/^non\b/i.test(t)) return { sens: 'non', sauf: /sauf/i.test(t), texte: t, saisi: true };
    if (/^oui\s*,/i.test(t)) return { sens: 'heures', texte: t, duree: verdict(desc).duree || 1440, saisi: true };
    if (/^oui\.?$/i.test(t)) return { sens: 'oui', saisi: true };
    return { sens: 'lire', texte: t, saisi: true };
  }

  /* ---------- afficher : la date du jour, les réponses ---------- */

  function heureDe(iso) {
    try {
      var h = '', m = '';
      new Intl.DateTimeFormat('fr-FR', { hour: 'numeric', minute: '2-digit', hourCycle: 'h23', timeZone: 'Europe/Paris' })
        .formatToParts(new Date(iso)).forEach(function (x) {
          if (x.type === 'hour') h = String(+x.value);
          if (x.type === 'minute') m = x.value;
        });
      return h && m ? h + ' h ' + m : '';
    } catch (e) { return ''; }
  }

  // « Niveaux du 5 octobre 2026 » en gros : on doit voir d'un coup d'œil que la carte
  // est celle du jour. Dessous, la source et l'heure.
  function poserDate(n, iso) {
    vider(n);
    var jour = date(iso), h = heureDe(iso);
    if (!jour) { n.textContent = 'Niveaux publiés par VigiEau, le service de l’État.'; return; }
    n.appendChild(el('span', 'ec-rst__date-jour', 'Niveaux du ' + jour));
    n.appendChild(el('span', 'ec-rst__date-src', 'Publiés par VigiEau, le service de l’État' + (h ? ', mis à jour à ' + h : '') + '.'));
    if (Date.now() - new Date(iso).getTime() > 2 * 864e5) {
      n.appendChild(el('span', 'ec-rst__date-vieux', 'VigiEau n’a rien publié de neuf depuis plus de deux jours : en cas de doute, la préfecture reste la référence.'));
    }
  }

  // Une ligne par question : la question, la réponse en couleur et, pour une adresse, le texte
  // de l'arrêté dessous, pour que chacun puisse vérifier.
  // Une ligne sans règle précise (r.absent) garde sa place, en gris : les cartes voisines restent alignées.
  function listeVerdicts(rep, avecTexte) {
    var ul = el('ul', 'ec-rst__verdicts');
    rep.forEach(function (r) {
      var li = el('li', 'ec-rst__verdict' + (r.absent ? ' ec-rst__verdict--absent' : ''));
      li.appendChild(el('span', 'ec-rst__q', r.titre));
      if (r.v) li.appendChild(el('span', 'ec-rst__v ec-rst__v--' + couleur(r.v),
        !avecTexte && r.v.sens === 'lire' && !r.v.saisi ? 'Cela dépend : voyez le tableau des règles' : libelle(r.v)));
      if (r.vaut) li.appendChild(el('span', 'ec-rst__q-texte', 'Vaut pour : ' + r.vaut + '.'));
      if (r.note) li.appendChild(el('span', 'ec-rst__q-texte', r.note));
      if (avecTexte) textes(r.usages).forEach(function (t) { li.appendChild(el('span', 'ec-rst__q-texte', t)); });
      ul.appendChild(li);
    });
    return ul;
  }

  // Les textes de l'arrêté sous une réponse : un par règle, un seul quand elles disent la même chose.
  function textes(usages) {
    var parTexte = {}, ordre = [];
    usages.forEach(function (u) {
      var d = (u.description || '').trim() || 'voyez le texte de l’arrêté.', n = normalNom(u.nom).replace(/\s*:$/, '');
      if (!parTexte[d]) { parTexte[d] = []; ordre.push(d); }
      if (parTexte[d].indexOf(n) < 0) parTexte[d].push(n);
    });
    return ordre.map(function (d) { return (ordre.length > 1 ? parTexte[d].join(', ') : 'L’arrêté') + ' : ' + d; });
  }

  // Quand l'arrêté ne vise pas le jardin, ce que l'on peut faire selon le niveau.
  function sansInterdiction(n) {
    return n >= 2 ? 'Cet arrêté ne fixe pas de règle propre au jardin. Les règles pour les particuliers sont juste en dessous.'
      : n === 1 ? 'Rien n’est interdit à ce niveau. La préfecture demande seulement d’économiser l’eau.'
        : 'Aucune restriction : vous pouvez utiliser cette eau normalement, sans la gaspiller.';
  }

  /* ---------- état du département (page département) ---------- */

  function initEtat(bloc) {
    var code = bloc.getAttribute('data-ec-rst-etat');
    var dateN = bloc.querySelector('[data-ec-rst-date]');
    var cible = bloc.querySelector('[data-ec-rst-verdicts]');
    var regles = [];
    try {
      var s = bloc.querySelector('script[data-ec-rst-regles]');
      if (s) regles = JSON.parse(s.textContent) || [];
    } catch (e) { regles = []; }
    departements().then(function (d) {
      var dep = d.parCode[code];
      if (!dep) throw new Error('département inconnu');
      var groupes = {}, niveaux = [];
      EAUX.forEach(function (e) {
        var n = niveauDep(dep, e.champ);
        var span = bloc.querySelector('[data-ec-rst-eau="' + e.type + '"] [data-ec-rst-niv]');
        if (span) poserPuce(span, n);
        if (n === 'x') return;
        if (!groupes[n]) { groupes[n] = []; niveaux.push(n); }
        groupes[n].push(e);
      });
      if (cible) reponsesDuJour(cible, groupes, niveaux, regles);
      var asOf = dep.availability && dep.availability.AEP && dep.availability.AEP.asOf;
      if (dateN) {
        if (disponible(dep)) poserDate(dateN, asOf || d.asOf);
        else dateN.textContent = "VigiEau ne publie pas de niveaux pour ce département aujourd'hui.";
      }
    }).catch(function () {
      bloc.querySelectorAll('[data-ec-rst-niv]').forEach(function (s) { poserPuce(s, 'x'); });
      if (dateN) messageVigieau(dateN, "Les niveaux du jour n'ont pas pu être chargés.");
    });
  }

  // Les réponses du jour, tirées du tableau des règles du département. Les eaux au même
  // niveau ont les mêmes réponses : une seule liste pour elles.
  function reponsesDuJour(cible, groupes, niveaux, regles) {
    vider(cible);
    niveaux.sort(function (a, b) { return b - a; });
    niveaux.forEach(function (n) {
      var eaux = groupes[n], g = el('div', 'ec-rst__jour');
      var tete = el('p', 'ec-rst__jour-eau');
      if (eaux.length === EAUX.length) tete.textContent = 'Robinet, rivière ou puits : les trois eaux sont au même niveau, les réponses valent pour les trois.';
      else {
        tete.textContent = "Avec l'eau " + eaux.map(function (e) { return e.court; }).join(' ou ');
        tete.appendChild(puce(n, true));
      }
      g.appendChild(tete);
      var rep = n >= 2 ? reponses(regles.map(function (r) { return { nom: r.usage, description: r['n' + n], verdict: r['v' + n] }; }), eaux[0].type) : [];
      if (rep.length) g.appendChild(listeVerdicts(rep, false));
      else g.appendChild(el('p', 'ec-rst__res-vide', n >= 2 ? 'Des restrictions s’appliquent : vérifiez votre adresse juste en dessous.' : sansInterdiction(n)));
      cible.appendChild(g);
    });
    cible.hidden = !niveaux.length;
  }

  /* ---------- départements voisins : pastille de l'eau du robinet ---------- */

  function initVoisins(puces) {
    departements().then(function (d) {
      puces.forEach(function (s) {
        var dep = d.parCode[s.parentNode.getAttribute('data-ec-rst-dep')];
        if (dep) poserPuce(s, niveauDep(dep, CHAMPS.aep)); else s.parentNode.removeChild(s);
      });
    }).catch(function () {
      puces.forEach(function (s) { if (s.parentNode) s.parentNode.removeChild(s); });
    });
  }

  /* ---------- carte de France (Carte sécheresse) ---------- */

  function initCarte(bloc) {
    var svg = bloc.querySelector('svg');
    if (!svg) return;
    var chemins = {};
    svg.querySelectorAll('path[data-dep]').forEach(function (p) { chemins[p.getAttribute('data-dep')] = p; });
    var onglets = [].slice.call(bloc.querySelectorAll('[data-ec-rst-champ]'));
    var select = bloc.querySelector('[data-ec-rst-select]');
    var info = bloc.querySelector('[data-ec-rst-info]');
    var dateN = bloc.querySelector('[data-ec-rst-date]');
    var tbody = bloc.querySelector('[data-ec-rst-tableau]');
    var om = bloc.querySelector('[data-ec-rst-om]');
    var champ = 'aep', choisi = null, donnees = null, boutonsOm = {};

    function peindre() {
      var comptes = { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, x: 0 };
      donnees.liste.forEach(function (dep) {
        var n = niveauDep(dep, CHAMPS[champ]);
        comptes[n] += 1;
        var p = chemins[dep.code];
        if (p) {
          p.setAttribute('data-niv', n);
          var t = p.querySelector('title');
          if (t) t.textContent = dep.nom + ' (' + dep.code + ') : ' + (n === 'x' ? 'indisponible' : NOMS[n]);
        }
        var b = boutonsOm[dep.code];
        if (b) b.firstChild.className = 'ec-niv ec-niv--' + n;
      });
      bloc.querySelectorAll('[data-ec-rst-compte]').forEach(function (b) {
        var c = comptes[b.getAttribute('data-ec-rst-compte')] || 0;
        b.textContent = ' : ' + c;
        b.parentNode.hidden = b.getAttribute('data-ec-rst-compte') === 'x' && !c;
      });
      if (choisi) remplirInfo(choisi);
    }

    function choisir(code) {
      if (choisi && chemins[choisi]) chemins[choisi].classList.remove('is-sel');
      choisi = code;
      var p = chemins[code];
      if (p) { p.classList.add('is-sel'); p.parentNode.appendChild(p); }
      Object.keys(boutonsOm).forEach(function (c) { boutonsOm[c].setAttribute('aria-pressed', c === code ? 'true' : 'false'); });
      if (select && select.value !== code) select.value = code;
      remplirInfo(code);
    }

    function remplirInfo(code) {
      var dep = donnees && donnees.parCode[code];
      if (!info || !dep) return;
      vider(info);
      info.appendChild(el('h3', 'eck-h3 ec-rst__info-nom', dep.nom + ' (' + dep.code + ')'));
      var ul = el('ul', 'ec-rst__info-eaux');
      EAUX.forEach(function (e) {
        var li = el('li', null, e.nom);
        li.appendChild(puce(niveauDep(dep, e.champ), true));
        ul.appendChild(li);
      });
      info.appendChild(ul);
      // Retour du 05/10 (Marseille) : le département en alerte renforcée, l'adresse en vigilance.
      // Le bouton mène à la page département quand elle existe : le lien vers l'adresse est alors dans la note.
      var page = pages()[code], p = el('p', 'ec-rst__info-lien'), a;
      var note = el('p', 'ec-rst__note', 'C’est le niveau maximal du département : il peut ne concerner qu’une partie de ses communes. La vôtre est peut-être à un niveau plus bas'
        + (page && page.url ? ' : ' : ', vérifiez votre adresse sous la carte.'));
      if (page && page.url) { note.appendChild(lien('#verifier', 'vérifiez votre adresse sous la carte')); note.appendChild(document.createTextNode('.')); }
      info.appendChild(note);
      if (page && page.url) {
        a = lien(page.url, 'Ce qui est permis ' + (page.dans || 'dans ce département'));
        a.className = 'eck-btn';
      } else {
        a = lien('#verifier', 'Vérifier les règles à votre adresse');
        a.className = 'eck-btn eck-btn--outline';
      }
      p.appendChild(a);
      info.appendChild(p);
    }

    function remplirListe() {
      if (select) {
        vider(select);
        var o = el('option', null, 'Choisir un département');
        o.value = '';
        select.appendChild(o);
        donnees.liste.forEach(function (dep) {
          var opt = el('option', null, dep.code + ' ' + dep.nom);
          opt.value = dep.code;
          select.appendChild(opt);
        });
        select.disabled = false;
        select.addEventListener('change', function () { if (select.value) choisir(select.value); });
      }
      if (om) {
        donnees.liste.forEach(function (dep) {
          if (chemins[dep.code]) return;
          var b = el('button');
          b.type = 'button';
          b.setAttribute('aria-pressed', 'false');
          b.appendChild(el('span', 'ec-niv'));
          b.appendChild(document.createTextNode(dep.nom));
          b.addEventListener('click', function () { choisir(dep.code); });
          boutonsOm[dep.code] = b;
          om.appendChild(b);
        });
        om.hidden = !Object.keys(boutonsOm).length;
      }
      if (tbody) {
        vider(tbody);
        donnees.liste.forEach(function (dep) {
          var tr = el('tr');
          tr.appendChild(el('th', null, dep.code + ' ' + dep.nom)).scope = 'row';
          EAUX.forEach(function (e) {
            var n = niveauDep(dep, e.champ);
            tr.appendChild(el('td', null, n === 'x' ? 'Indisponible' : NOMS[n]));
          });
          tbody.appendChild(tr);
        });
      }
    }

    svg.addEventListener('click', function (ev) {
      var p = ev.target.closest && ev.target.closest('path[data-dep]');
      if (p && donnees) choisir(p.getAttribute('data-dep'));
    });

    onglets.forEach(function (o, i) {
      o.addEventListener('click', function () {
        champ = o.getAttribute('data-ec-rst-champ');
        onglets.forEach(function (x) {
          var actif = x === o;
          x.setAttribute('aria-selected', actif ? 'true' : 'false');
          x.tabIndex = actif ? 0 : -1;
        });
        if (donnees) peindre();
      });
      o.addEventListener('keydown', function (ev) {
        var j = ev.key === 'ArrowRight' ? i + 1 : ev.key === 'ArrowLeft' ? i - 1 : ev.key === 'Home' ? 0 : ev.key === 'End' ? onglets.length - 1 : null;
        if (j === null) return;
        ev.preventDefault();
        var cible = onglets[(j + onglets.length) % onglets.length];
        cible.focus();
        cible.click();
      });
    });

    departements().then(function (d) {
      donnees = d;
      bloc.classList.remove('ec-rst__carte--attente');
      remplirListe();
      peindre();
      if (dateN) poserDate(dateN, d.asOf);
      var h = (location.hash || '').replace('#dep-', '');
      if (h && d.parCode[h]) choisir(h);
    }).catch(function () {
      if (dateN) messageVigieau(dateN, "La carte du jour n'a pas pu être chargée.");
      if (select) select.options[0].textContent = 'Niveaux indisponibles';
    });
  }

  /* ---------- vérification par adresse ---------- */

  function codeDepartement(props) {
    return ((props && props.context) || '').split(',')[0].trim();
  }

  // Deux recherches en parallèle : l'IGN classe parfois une rue avant la commune du même nom.
  function geocoder(q, depPage) {
    var u = GEO + '?q=' + encodeURIComponent(q) + '&limit=6';
    return Promise.all([
      lireJSON(u).catch(function () { return null; }),
      lireJSON(u + '&type=municipality').catch(function () { return null; })
    ]).then(function (r) {
      if (!r[0] && !r[1]) throw new Error('géocodage indisponible');
      var tous = (r[0] && r[0].features) || [], communes = (r[1] && r[1].features) || [];
      var liste = /\d/.test(q) ? tous.concat(communes) : communes.concat(tous);
      var vus = {}, propres = [];
      liste.forEach(function (f) {
        var p = f && f.properties, c = f && f.geometry && f.geometry.coordinates;
        if (!p || !c) return;
        var k = p.label + '|' + p.citycode;
        if (vus[k]) return;
        vus[k] = 1;
        propres.push(f);
      });
      if (depPage) {
        var dans = propres.filter(function (f) { return codeDepartement(f.properties) === depPage && f.properties.score >= 0.5; });
        propres = dans.concat(propres.filter(function (f) { return dans.indexOf(f) < 0; }));
      }
      return propres;
    });
  }

  function zones(f) {
    var p = f.properties, c = f.geometry.coordinates;
    var base = API + '/zones?profil=particulier&commune=' + encodeURIComponent(p.citycode);
    var parPoint = base + '&lon=' + c[0] + '&lat=' + c[1];
    if (p.type !== 'municipality') return lireJSON(parPoint).then(function (z) { return { zones: z }; });
    // Une commune entière : si elle est coupée en plusieurs zones, VigiEau répond 409 et
    // il faut une position. On prend alors le centre de la commune, et on le dit.
    return lireJSON(base).then(function (z) { return { zones: z }; }, function (e) {
      if (e.status !== 409) throw e;
      return lireJSON(parPoint).then(function (z) { return { zones: z, centre: true }; });
    });
  }

  function minimal(f) {
    var p = f.properties;
    return { type: 'Feature', geometry: { coordinates: f.geometry.coordinates },
      properties: { label: p.label, type: p.type, city: p.city, citycode: p.citycode, context: p.context, score: p.score } };
  }

  function lireMemoire() {
    try { var v = localStorage.getItem(CLE); return v ? JSON.parse(v) : null; } catch (e) { return null; }
  }
  function ecrireMemoire(f) {
    try { if (f) localStorage.setItem(CLE, JSON.stringify(minimal(f))); else localStorage.removeItem(CLE); } catch (e) { /* stockage bloqué */ }
  }

  function initAdresse(bloc) {
    var depPage = bloc.getAttribute('data-dep') || '';
    var hub = bloc.getAttribute('data-hub') || '';
    var dansPage = bloc.getAttribute('data-dans') || '';
    var zone = bloc.querySelector('[data-ec-rst-form]');
    var champ = bloc.querySelector('[data-ec-rst-q]');
    var bouton = bloc.querySelector('[data-ec-rst-go]');
    var retenir = bloc.querySelector('[data-ec-rst-retenir]');
    var oubli = bloc.querySelector('[data-ec-rst-oubli]');
    var statut = bloc.querySelector('[data-ec-rst-statut]');
    var choix = bloc.querySelector('[data-ec-rst-choix]');
    var resultat = bloc.querySelector('[data-ec-rst-resultat]');
    if (!zone || !champ || !bouton || !resultat) return;
    var tour = 0, actuel = null;

    function dire(texte) { statut.hidden = false; vider(statut); if (texte) statut.textContent = texte; }
    function occupe(oui) { bouton.disabled = oui; bloc.setAttribute('aria-busy', oui ? 'true' : 'false'); }

    function lancer() {
      var q = champ.value.trim();
      if (q.length < 3) { dire('Entrez au moins trois caractères : une adresse, une commune ou un code postal.'); champ.focus(); return; }
      var t = ++tour;
      occupe(true);
      resultat.hidden = true;
      choix.hidden = true;
      dire('Recherche de l’adresse…');
      geocoder(q, depPage).then(function (liste) {
        if (t !== tour) return;
        if (!liste.length) { occupe(false); dire('Adresse introuvable. Essayez avec le nom de la commune ou son code postal.'); return; }
        verifier(liste[0], liste.slice(1, 6), t);
      }).catch(function () {
        if (t !== tour) return;
        occupe(false);
        messageVigieau(statut, "Le service d'adresses de l'IGN ne répond pas. Réessayez dans un instant.");
      });
    }

    function verifier(f, autres, t) {
      t = t || ++tour;
      occupe(true);
      actuel = f;
      dire('Lecture des restrictions du jour…');
      remplirChoix(f, autres);
      Promise.all([zones(f), departements().catch(function () { return null; })]).then(function (r) {
        if (t !== tour) return;
        occupe(false);
        dire('');
        statut.hidden = true;
        afficher(f, r[0], r[1]);
        if (retenir && retenir.checked) { ecrireMemoire(f); if (oubli) oubli.hidden = false; }
      }).catch(function (e) {
        if (t !== tour) return;
        occupe(false);
        if (e && e.status === 404) {
          var vide = function (d) { if (t !== tour) return; dire(''); statut.hidden = true; afficher(f, { zones: [] }, d); };
          departements().then(vide, function () { vide(null); });
          return;
        }
        if (e && e.status === 410) {
          messageVigieau(statut, 'VigiEau indique que les restrictions de ce secteur ne sont pas publiées pour le moment. La préfecture du département reste la référence.');
          return;
        }
        messageVigieau(statut, 'VigiEau ne répond pas pour le moment. Réessayez dans un instant.');
      });
    }

    function remplirChoix(f, autres) {
      vider(choix);
      if (!autres || !autres.length) { choix.hidden = true; return; }
      choix.appendChild(el('span', null, 'Pas la bonne adresse ?'));
      autres.forEach(function (a, i) {
        var b = el('button', null, a.properties.label + (a.properties.context ? ' (' + codeDepartement(a.properties) + ')' : ''));
        b.type = 'button';
        b.addEventListener('click', function () {
          champ.value = a.properties.label;
          var reste = autres.slice(0, i).concat(autres.slice(i + 1)).concat([f]);
          verifier(a, reste);
        });
        choix.appendChild(b);
      });
      choix.hidden = false;
    }

    function afficher(f, rep, deps) {
      var p = f.properties, codeDep = codeDepartement(p);
      var dep = deps && deps.parCode[codeDep];
      // Le nom du département : VigiEau, sinon le contexte de l'IGN (« 13, Bouches-du-Rhône, … »).
      var nomDep = dep ? dep.nom : ((p.context || '').split(',')[1] || '').trim();
      vider(resultat);
      var lieu = el('p', 'ec-rst__lieu');
      lieu.appendChild(el('span', 'ec-rst__lieu-titre', 'Résultat pour'));
      lieu.appendChild(document.createTextNode(p.label + (nomDep ? ', ' + nomDep + ' (' + codeDep + ')' : '')));
      resultat.appendChild(lieu);

      // Adresse hors du département de la page : on le dit en clair, avec la ville et le
      // département trouvés, et on renvoie vers la bonne page si elle existe.
      var page = pages()[codeDep];
      if (depPage && codeDep && codeDep !== depPage) {
        var c = el('div', 'ec-rst__ailleurs');
        c.appendChild(el('p', 'ec-rst__ailleurs-titre', 'Cette adresse est à ' + (p.city || p.label)
          + (nomDep ? ' (' + nomDep + ', ' + codeDep + ')' : '') + ', pas ' + (dansPage || 'dans ce département') + '.'));
        var t = el('p', null, 'Les réponses ci-dessous sont bien celles de cette adresse. ');
        if (page && page.url) t.appendChild(lien(page.url, 'Voir ce qui est permis ' + (page.dans || 'dans ce département')));
        else if (hub) t.appendChild(lien(hub, 'Voir le niveau de chaque département sur la carte'));
        c.appendChild(t);
        resultat.appendChild(c);
      } else if (!depPage && page && page.url) {
        // Un bouton, comme dans le panneau de la carte : c'est l'entrée vers la page département.
        var l = el('p', 'ec-rst__info-lien'), b = lien(page.url, 'Ce qui est permis ' + (page.dans || 'dans ce département'));
        b.className = 'eck-btn';
        l.appendChild(b);
        resultat.appendChild(l);
      }
      // L'IGN rapproche l'adresse de la plus proche qu'il connaît : sous 0,7, c'est souvent une autre.
      if (p.score < 0.7) {
        resultat.appendChild(el('p', 'ec-rst__avert', 'Adresse trouvée de façon approchée : vérifiez qu’il s’agit bien de la vôtre. Sinon, '
          + (choix.hidden ? 'ajoutez le code postal ou le nom de la commune.' : 'choisissez une autre proposition juste au-dessus, ou ajoutez le code postal.')));
      }
      if (rep.centre) resultat.appendChild(el('p', 'ec-rst__avert', 'Cette commune est partagée entre plusieurs zones : le résultat vaut pour son centre. Entrez votre rue pour un résultat exact.'));

      var liste = (rep.zones || []).filter(function (z) { return z && z.type; });
      // L'adresse est à un niveau plus bas que la couleur du département sur la carte : on dit pourquoi
      // (retour du 05/10 : Marseille en vigilance, les Bouches-du-Rhône en alerte renforcée).
      var nAdr = liste.reduce(function (m, z) { return Math.max(m, niveau(z.niveauGravite)); }, 0);
      var nDep = dep ? niveauDep(dep, CHAMPS.max) : 'x';
      if (nDep !== 'x' && nAdr < nDep) resultat.appendChild(ecart(codeDep, nAdr, nDep, liste));

      if (dep && !disponible(dep) && !liste.length) {
        var r = el('p', 'ec-rst__statut');
        messageVigieau(r, "VigiEau ne publie pas les restrictions de ce département aujourd'hui.");
        resultat.appendChild(r);
      } else if (!liste.length) {
        resultat.appendChild(el('p', 'ec-rst__statut', "Aucune restriction d'eau à cette adresse aujourd'hui : vous pouvez arroser normalement, sans gaspiller."));
      } else {
        resultat.appendChild(grille(colonnes(liste)));
        resultat.appendChild(pluie());
      }
      var src = el('p', 'ec-rst__note');
      src.appendChild(document.createTextNode('Source : '));
      src.appendChild(lien(VIGIEAU, 'VigiEau'));
      var maintenant = new Date().toISOString(), h = heureDe(maintenant);
      src.appendChild(document.createTextNode(', consulté le ' + date(maintenant) + (h ? ' à ' + h : '') + '. Seul l’arrêté préfectoral fait foi.'));
      resultat.appendChild(src);
      resultat.hidden = false;
    }

    // « Chez vous : vigilance, pas alerte renforcée » : la couleur du département est son niveau
    // maximal, atteint dans une partie de ses zones seulement.
    function ecart(code, nAdr, nDep, liste) {
      var c = el('div', 'eck-callout eck-callout--info ec-rst__ecart'), d = el('div');
      var bas = function (n) { return NOMS[n].toLowerCase(); };
      d.appendChild(el('p', 'eck-callout__title', 'Chez vous : ' + bas(nAdr) + ', pas ' + bas(nDep)));
      var t = el('div', 'eck-callout__text');
      var debut = 'Sur la carte, le département est en ' + bas(nDep) + ' : c’est le niveau maximal, atteint dans ';
      var p1 = el('p', null, debut + 'une partie du département.');
      t.appendChild(p1);
      var niveaux = [];
      liste.forEach(function (z) { var n = niveau(z.niveauGravite); if (niveaux.indexOf(n) < 0) niveaux.push(n); });
      niveaux.sort();
      var en = enumerer(niveaux.map(function (n) { return 'en ' + bas(n); })).replace(/ et (en [^,]*)$/, ' ou $1');
      var noms = nomsZones(liste), ici;
      if (!liste.length) ici = 'Votre adresse n’a aucune restriction aujourd’hui.';
      else if (!noms.length) ici = 'Votre adresse est ' + en + '.';
      else ici = 'Votre adresse est dans ' + (noms.length > 1 ? 'les zones ' : 'la zone ') + enumerer(noms)
        + (niveaux.length > 1 ? '. Selon l’eau utilisée, elle est ' + en + '.' : ', ' + en + '.');
      t.appendChild(el('p', null, ici));
      t.appendChild(el('p', null, 'Les règles du niveau ' + bas(nDep) + ' ne s’appliquent donc pas chez vous'
        + (liste.length ? ' : seules comptent les réponses ci-dessous.' : '.')));
      d.appendChild(t);
      c.appendChild(d);
      zonesDep(code).then(function (zs) {
        var hautes = (zs || []).filter(function (z) { return z && niveau(z.niveauGravite) === nDep; });
        var n = nomsZones(hautes), x;
        if (n.length === 1) x = 'une de ses zones, ' + n[0];
        else if (n.length > 1 && n.length < 5) x = CHIFFRES[n.length] + ' de ses zones : ' + enumerer(n);
        else if (n.length) x = n.length + ' de ses zones';
        else if (hautes.length) x = 'certaines communes, pour l’eau du robinet';
        if (x) p1.textContent = debut + x + '.';
      }).catch(function () {});
      return c;
    }

    // Une colonne par jeu de règles : les eaux qui ont les mêmes règles n'en font qu'une
    // (Marseille : robinet, rivière et puits sont dans la même zone, avec le même arrêté).
    function colonnes(liste) {
      var cols = [], parSig = {};
      EAUX.forEach(function (e) {
        var zs = liste.filter(function (z) { return z.type === e.type; });
        (zs.length ? zs : [null]).forEach(function (z) {
          var usages = z ? (z.usages || []).filter(function (u) { return u && u.nom && u.concerneParticulier !== false; }) : [];
          var rep = reponses(usages, e.type), n = z ? niveau(z.niveauGravite) : 0, a = z && z.arrete;
          var sig = !z ? 'vide' : [a ? a.id || a.cheminFichier || '' : '', n,
            usages.map(function (u) { return normalNom(u.nom) + '=' + normal(u.description); }).sort().join('¦'),
            rep.map(function (r) { return r.k + '=' + libelle(r.v); }).join('¦')].join('#');
          var c = parSig[sig];
          if (!c) { c = parSig[sig] = { eaux: [], zones: [], n: n, usages: usages, rep: rep, arrete: a }; cols.push(c); }
          if (c.eaux.indexOf(e) < 0) c.eaux.push(e);
          if (z) c.zones.push(z);
        });
      });
      return cols;
    }

    // Les mêmes questions, dans le même ordre, dans chaque colonne : les réponses se lisent en ligne.
    function grille(cols) {
      var parK = {}, ks = [];
      cols.forEach(function (c) { c.rep.forEach(function (r) { if (!parK[r.k]) { parK[r.k] = r; ks.push(r.k); } }); });
      ks.sort(function (a, b) { return ORDRE.indexOf(parK[a].cle) - ORDRE.indexOf(parK[b].cle); });
      cols.forEach(function (c) {
        c.lignes = ks.map(function (k) {
          var r = c.rep.filter(function (x) { return x.k === k; })[0], l = parK[k];
          if (r) return r;
          var vide = { titre: l.titre, cle: l.cle, k: k, usages: [] };
          if (!c.zones.length || c.n === 0) vide.v = { sens: 'oui' };
          else if (c.n === 1) vide.v = { sens: 'econome' };
          else {
            vide.absent = true;
            vide.v = { sens: 'lire', texte: 'Cela dépend' };
            vide.note = 'Rien de précis dans l’arrêté pour cette eau : voyez toutes les règles ci-dessous.';
          }
          return vide;
        });
      });
      // Une seule réponse pour tout le jardin dans chaque colonne : une ligne au lieu de cinq.
      var seule = ks.length >= 2 && cols.every(function (c) {
        return c.lignes.every(function (r) { return !r.absent && libelle(r.v) === libelle(c.lignes[0].v); });
      });
      if (seule) cols.forEach(function (c) {
        var usages = [];
        c.lignes.forEach(function (r) { usages = usages.concat(r.usages); });
        c.lignes = [{ titre: 'Pour tout le jardin', cle: 'tout', k: 'tout', v: c.lignes[0].v, usages: usages,
          vaut: c.lignes.map(function (r) { return r.titre.charAt(0).toLowerCase() + r.titre.slice(1); }).join(', ') }];
      });
      var q = seule ? 1 : ks.length;
      var g = el('div', 'ec-rst__res' + (cols.length === 1 ? ' ec-rst__res--1' : cols.length <= 3 ? ' ec-rst__res--aligne' : ''));
      g.style.setProperty('--cols', cols.length);
      g.style.setProperty('--rows', 1 + Math.max(q, 1) + 2);
      cols.forEach(function (c) { g.appendChild(carte(c, q)); });
      return g;
    }

    // Une carte : l'en-tête, les réponses, l'arrêté, toutes les règles. Chaque partie a sa
    // rangée, vide s'il le faut, pour que les cartes voisines restent alignées.
    function carte(c, q) {
      var k = el('div', 'ec-rst__res-carte');
      var tete = el('div', 'ec-rst__res-tete');
      var titre = c.eaux.length === EAUX.length ? 'Robinet, rivière ou puits : mêmes règles'
        : c.eaux.length > 1 ? "Avec l'eau " + c.eaux.map(function (e) { return e.court; }).join(' ou ') : c.eaux[0].titre;
      tete.appendChild(el('h3', 'ec-rst__res-eau', titre));
      tete.appendChild(puce(c.n));
      // Le nom des zones « robinet » est un nom de fichier administratif : on ne l'affiche pas.
      var noms = nomsZones(c.zones);
      if (noms.length) tete.appendChild(el('p', 'ec-rst__res-zone', (noms.length > 1 ? 'Zones : ' : 'Zone : ') + noms.join(' ; ')));
      if (!c.zones.length && q) tete.appendChild(el('p', 'ec-rst__res-vide', sansInterdiction(0)));
      k.appendChild(tete);

      if (q) {
        var ul = listeVerdicts(c.lignes, true);
        ul.style.setProperty('--q', c.lignes.length);
        k.appendChild(ul);
      } else {
        k.appendChild(el('p', 'ec-rst__res-vide', !c.zones.length || c.usages.length || c.n < 2 ? sansInterdiction(c.n)
          : 'VigiEau ne détaille pas les règles de cette zone : lisez l’arrêté ci-dessous.'));
      }

      var a = c.arrete, p = el('p', 'ec-rst__res-arrete');
      if (a) {
        var du = date(a.dateDebutValidite), au = date(a.dateFinValidite);
        p.appendChild(document.createTextNode(du && au ? 'Arrêté valable du ' + du + ' au ' + au + '. ' : du ? 'Arrêté valable depuis le ' + du + '. ' : ''));
        if (/^https:\/\//.test(a.cheminFichier || '')) p.appendChild(lien(a.cheminFichier, 'Lire l’arrêté (PDF)'));
      }
      k.appendChild(p.firstChild ? p : el('div', 'ec-rst__res-rien'));

      if (c.usages.length) {
        var d = el('details');
        d.appendChild(el('summary', null, 'Toutes les règles pour les particuliers (' + c.usages.length + ')'));
        d.appendChild(listeUsages(c.usages));
        k.appendChild(d);
      } else k.appendChild(el('div', 'ec-rst__res-rien'));
      return k;
    }

    function listeUsages(usages) {
      var ul = el('ul', 'ec-rst__usages');
      usages.forEach(function (u) {
        var li = el('li');
        li.appendChild(el('span', 'ec-rst__usage-nom', u.nom));
        li.appendChild(el('span', 'ec-rst__usage-regle', (u.description || '').trim() || 'Voir l’arrêté.'));
        ul.appendChild(li);
      });
      return ul;
    }

    function pluie() {
      var c = el('div', 'eck-callout eck-callout--info ec-rst__res-pluie');
      var d = el('div');
      d.appendChild(el('p', 'eck-callout__title', 'Et l’eau de pluie ?'));
      var t = el('p', 'eck-callout__text');
      t.appendChild(document.createTextNode('Selon le '));
      t.appendChild(lien(GUIDE, 'guide national sécheresse'));
      t.appendChild(document.createTextNode(', les restrictions ne s’appliquent pas à l’eau de pluie récupérée. Vérifiez tout de même l’arrêté de votre département.'));
      d.appendChild(t);
      c.appendChild(d);
      return c;
    }

    bouton.addEventListener('click', lancer);
    champ.addEventListener('keydown', function (ev) { if (ev.key === 'Enter') { ev.preventDefault(); lancer(); } });
    if (retenir) retenir.addEventListener('change', function () {
      if (retenir.checked && actuel) { ecrireMemoire(actuel); if (oubli) oubli.hidden = false; }
      if (!retenir.checked) { ecrireMemoire(null); if (oubli) oubli.hidden = true; }
    });
    if (oubli) oubli.addEventListener('click', function () {
      ecrireMemoire(null);
      oubli.hidden = true;
      if (retenir) retenir.checked = false;
      dire('Adresse oubliée sur cet appareil.');
    });

    zone.hidden = false;
    var m = lireMemoire();
    if (m && m.properties && m.geometry && m.geometry.coordinates) {
      champ.value = m.properties.label || '';
      if (retenir) retenir.checked = true;
      if (oubli) oubli.hidden = false;
      verifier(m, []);
    }
  }

  /* ---------- démarrage ---------- */

  function init(racine) {
    racine = racine || document;
    function chaque(sel, fn) {
      racine.querySelectorAll(sel).forEach(function (n) {
        if (n.hasAttribute('data-ec-rst-pret')) return;
        n.setAttribute('data-ec-rst-pret', '');
        fn(n);
      });
    }
    chaque('[data-ec-rst-etat]', initEtat);
    chaque('[data-ec-rst-carte]', initCarte);
    chaque('[data-ec-rst-adresse]', initAdresse);
    var puces = [].slice.call(racine.querySelectorAll('[data-ec-rst-dep] > [data-ec-rst-niv]:not([data-ec-rst-pret])'));
    puces.forEach(function (s) { s.setAttribute('data-ec-rst-pret', ''); });
    if (puces.length) initVoisins(puces);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (ev) { pagesDep = null; init(ev.target); });
})();
